import { render, staticRenderFns } from "./user-permission.vue?vue&type=template&id=4895da04&scoped=true&"
import script from "./user-permission.vue?vue&type=script&lang=js&"
export * from "./user-permission.vue?vue&type=script&lang=js&"
import style0 from "./user-permission.vue?vue&type=style&index=0&id=4895da04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895da04",
  null
  
)

export default component.exports